import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CountryState {
  countryList: any[];
}

const initialState: CountryState = {
  countryList: [],
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    setCountryList(state, action: PayloadAction<any[]>) {
      state.countryList = action.payload;
    },
    resetCountryList: () => {
        return initialState;
    },
  },
});

export const { setCountryList,resetCountryList } = countrySlice.actions;
export default countrySlice.reducer;